import reject from 'lodash/reject';

import {
  FETCH_WAITING_LIST_CUSTOMERS,
  FETCH_WAITING_LIST_CUSTOMERS_ERROR,
  FETCH_WAITING_LIST_CUSTOMERS_SUCCESS,
  RESET_WAITING_LIST_CUSTOMERS,
} from './constants';

const initialState = {
  items: null,
  isFetching: false,
  updatedAt: null,
};

const waitingListCustomers = (state = initialState, { type, payload }) => {
  switch (type) {
    case RESET_WAITING_LIST_CUSTOMERS:
      return initialState;

    case FETCH_WAITING_LIST_CUSTOMERS:
      return {
        ...state,
        isFetching: true,
      };

    case FETCH_WAITING_LIST_CUSTOMERS_SUCCESS:
      return {
        isFetching: false,
        items: [
          ...reject(state.items, { day: payload.day }),
          { day: payload.day, customers: payload.customers },
        ],
        updatedAt: [
          ...reject(state.updatedAt, { day: payload.day }),
          { day: payload.day, timeStamp: payload.updatedAt },
        ],
      };

    case FETCH_WAITING_LIST_CUSTOMERS_ERROR:
      return {
        ...state,
        isFetching: false,
      };

    default:
      return state;
  }
};

export default waitingListCustomers;
